export default {
    citizenshipDocCountrySelects: ['USA', 'Canada', 'Russia', 'Belarus', 'Czech Republic', 'Slovakia', 'Finland', 'Sweden', 'Latvia', 'Switzerland', 'Denmark', 'Slovenia', 'Austria', 
        'Norway', 'Bulgaria', 'Germany', 'Netherlands', 'Uzbekistan', 'France', 'Kazakhstan', 'United Kingdom', 'Moldova'],
    citizenshipDocDateFields: ['issuedDate', 'expiringDate'],
    documentTypeSelects: ['Drivers License', 'Green Card', 'Passport', 'Visa'],
    driversLicenseDocumentType: 'Drivers License',
    greenCardDocumentType: 'Green Card',
    passportDocumentType: 'Passport',
    visaDocumentType: 'Visa',
    visaTypeSelects: ['B1', 'B2', "B1/B2", 'H1B', 'H2B', 'O1', 'P1', 'P4', 'Schengen', 'V-1', 'WX-1']
}